import { TMenuProps } from '@idaho-aeyc/ui-kit';
import { useGetEventUrlQuery } from 'redux/apiSlice/events.slice';
import {
  EEventDetailsAllowedActions,
  EEventStatus,
} from 'data/types/events.types';
import { useTranslation } from '@packages/utils';
import ActionsButtonDetailsPage from 'components/Shared/ActionsButtonDetailsPage';
import { TActionsGroupProps } from '../Actions.types';
import CopyUrlAction from '../CopyUrlAction';
import DownloadLandingQrAction from '../DownloadLandingQrAction';
import CancelAction from '../CancelAction';
import DuplicateAction from '../DuplicateAction';
import DeleteAction from '../DeleteAction';
import CloseAction from '../CloseAction';
import CopyUrls from '../CopyUrlAction/CopyUrls';
import CopyAttendanceListUrl from '../CopyUrlAction/CopyAttendanceListUrl';
import CopyChildCareUrl from '../CopyUrlAction/CopyChildCareUrl';
import AddRegistrationAction from '../AddRegistrationAction';

const ActionsGroupButton = ({ id, data }: TActionsGroupProps) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.events.details.actions',
  });

  const { data: eventUrl } = useGetEventUrlQuery(
    {
      eventId: id,
    },
    {
      skip: data?.status !== EEventStatus.PUBLISHED,
    },
  );

  const actionsMapper: Partial<
    Record<EEventDetailsAllowedActions, React.ReactElement | null>
  > = {
    CANCEL: <CancelAction id={id} />,
    DUPLICATE: <DuplicateAction id={id} />,
    DELETE: <DeleteAction id={id} />,
    COPY_URL: <CopyUrlAction />,
    DOWNLOAD_LANDING_QR: <DownloadLandingQrAction eventUrl={eventUrl} />,
    CLOSE: <CloseAction id={id} />,
  };

  // @ts-ignore // TODO NONA review
  const items: TMenuProps['items'] = (data?.allowedActions || []).map(
    action => {
      if (action === EEventDetailsAllowedActions.COPY_URL) {
        return {
          label: actionsMapper[action],
          key: action,
          children: [
            {
              key: '1',
              type: 'group',
              label: t('copy-url.PUBLIC_PAGE'),
              children: [
                {
                  key: '1-1',
                  label: (
                    <CopyUrls
                      copyText={t('copy-url.COPY')}
                      copyUrl={eventUrl}
                    />
                  ),
                },
              ],
            },
            data?.childcareProvided?.value
              ? {
                  key: '2',
                  type: 'group',
                  label: t('copy-url.CHILD_CARE_URL'),
                  children: [
                    {
                      key: '2-1',
                      label: (
                        <CopyChildCareUrl
                          eventId={id}
                          copyText={t('copy-url.COPY')}
                        />
                      ),
                    },
                  ],
                }
              : null,
            {
              key: '3',
              type: 'group',
              label: t('copy-url.TOTAL_ATTENDANCE_LIST'),
              children: data?.actualSessionDates?.map((item, index) => ({
                key: `3-${index}`,
                label: <CopyAttendanceListUrl eventId={id} date={item} />,
              })),
            },
          ],
        };
      }
      return {
        label: actionsMapper[action],
        key: action,
      };
    },
  );

  // GROW-4362: role / assignment / state rules live server-side in
  // `allowRegistration`; the FE only mirrors that flag.
  if (data?.allowRegistration && data?.requiresRegistration) {
    items?.push({
      label: <AddRegistrationAction id={id} event={data} />,
      key: 'ADD_REGISTRATION',
    });
  }

  if (!items?.length) {
    return null;
  }

  return <ActionsButtonDetailsPage items={items} />;
};

export default ActionsGroupButton;
